import { getBooleanFromValue } from '@/global/utils/utils'

export default {
  computed: {
    basicInfoEditConfig () {
      return {
        title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
        key: 'basicInfo',
        formData: this.formData?.item,
        initialAutocompletes: this.formData?.initialAutocompletes,
        onTabChange: () => {
          this.showMainEditButtons = true
        },
        editUpdate: (event) => {
          const { edit } = event || {}
          this.$set(this.disableTabs, 'canBus', edit)
          this.$set(this.disableTabs, 'readouts', edit)
          this.$set(this.disableTabs, 'documents', edit)
          this.$set(this.disableTabs, 'inspections', edit)
          this.$set(this.disableTabs, 'insurances', edit)
          this.$set(this.disableTabs, 'leasing', edit)
          this.$set(this.disableTabs, 'rangeLimits', edit)
          this.$set(this.disableTabs, 'serviceIntervals', edit)
          this.$set(this.disableTabs, 'serviceHistory', edit)
          this.$set(this.disableTabs, 'comments', edit)
          this.$set(this.disableTabs, 'damages', edit)
        },
        tabContent: [
          {
            title: this.$t('fleet/vehicle/basic_info_tab.tab_label'),
            component: this.columnsContentComponent,
            rows: [
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 2,
                images: {
                  count: 6,
                  perRowCount: 3,
                  formKeyForDelete: 'filesToDelete',
                  keys: ['images']
                },
                fields: [
                  {
                    key: 'garage_number',
                    label: this.$t('fleet/vehicle_attribute.garage_number'),
                    type: 'text',
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'registration',
                    label: this.$t('fleet/vehicle.registration'),
                    creatable: true,
                    editable: true,
                    visible: true
                  },
                  {
                    key: 'status_icon',
                    label: this.$t('fleet/vehicle.status'),
                    type: 'image',
                    alt: '/img/icons/icon_small_status_unknown.png',
                    basePath: '/img/icons/',
                    width: 20,
                    height: 20,
                    creatable: false,
                    visible: true,
                    editable: false
                  },
                  {
                    key: 'label',
                    label: this.$t('fleet/vehicle.label'),
                    type: 'text',
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'gsm_signal_icon',
                    label: this.$t('fleet/vehicle.gsm_signal'),
                    type: 'image',
                    basePath: '/img/icons/',
                    alt: '/img/icons/icon_small_signal_0.png',
                    width: 20,
                    height: 20,
                    creatable: false,
                    visible: true,
                    editable: false
                  },
                  {
                    key: 'color',
                    label: this.$t('fleet/vehicle.color'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/colors',
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'driver',
                    label: this.$t('fleet/vehicle.driver'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'people',
                      route: 'people/autocomplete',
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'type',
                    label: this.$t('fleet/vehicle.type'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicles/types',
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'measured_battery_voltage',
                    label: this.$t('fleet/vehicle_attribute.battery_voltage'),
                    creatable: false,
                    visible: true,
                    editable: false
                  },
                  {
                    key: 'group',
                    label: this.$t('fleet/vehicle.group'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'groups/autocomplete',
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'tags',
                    label: this.$t('fleet.vehicle_tags'),
                    type: 'combobox',
                    autocomplete_options: {
                      module: 'fleet',
                      route: 'vehicle-tags/autocomplete',
                      fetchInitial: false,
                      allowCustomValue: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  }
                ]
              },
              {
                disabled: !getBooleanFromValue(this.permissions?.canEdit),
                columnsCount: 4,
                fields: [
                  {
                    key: 'odometer',
                    label: this.$t('fleet/vehicle.odometer'),
                    creatable: false,
                    visible: true,
                    editable: false
                  },
                  {
                    key: 'last_update_human_datetime',
                    label: this.$t('fleet/vehicle.last_update'),
                    creatable: false,
                    visible: true,
                    editable: false
                  },
                  {
                    key: 'tracker',
                    label: this.$t('fleet/vehicle.tracker'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      module: 'base',
                      route: 'tracker/autocomplete',
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'availability_status',
                    label: this.$t('fleet/vehicle_availability_status.column'),
                    type: 'autocomplete',
                    autocomplete_options: {
                      fetchInitial: false
                    },
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    key: 'engine_ignition_lock',
                    type: 'base-switch',
                    label: this.$t('fleet/vehicle.engine_ignition_lock'),
                    creatable: true,
                    visible: true,
                    editable: true
                  },
                  {
                    // Marks the vehicle as one the winter service dispatches. Turning it
                    // on is what opens the winter service tab, where the configuration
                    // the tasks read off the vehicle is set up.
                    key: 'is_winter_service',
                    type: 'base-switch',
                    label: this.$t('fleet/vehicle.is_winter_service'),
                    creatable: true,
                    visible: true,
                    editable: true
                  }
                ]
              }
            ]
          }
        ]
      }
    }
  }
}
